














import { Component, Vue, Prop } from 'vue-property-decorator'
import AlarmForm from './AlarmForm.vue'
import { Alarm, AddAlarm } from '../store/alarm'
import { namespace } from 'vuex-class'
const alarmStore = namespace('alarm')
@Component({ components: { AlarmForm } })
export default class EditAlarmModal extends Vue {
  dialog = false
  @alarmStore.Action edit!: (alarm: Alarm) => Promise<Alarm>
  @Prop() alarm!: Alarm

  async editAlarm(alarm: AddAlarm) {
    await this.edit({ id: this.alarm.id, ...alarm })
    this.dialog = false
  }
}
